import styled from "@emotion/styled";

const Container = styled.div`
  font-size: ${({ fontSize, isMobile }) =>
    fontSize || (isMobile ? "13px" : "15px")};
  font-weight: ${({ fontWeight }) => fontWeight || 500};
  color: ${({ color }) => color || "black"};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const forprofile = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const LeftButton = styled.div`
  display: flex;
  align-items: center;
  font-size: ${({ isMobile }) => (isMobile ? "16px" : "18px")};
`;

const RightButton = styled.div`
  display: flex;
  align-items: center;
  font-size: ${({ isMobile }) => (isMobile ? "16px" : "18px")};
`;

const Subcaption = styled.div`
  font-size: ${({ isMobile }) => (isMobile ? "9px" : "10px")};
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MUIButtonrt = {
  textTransform: "capitalize",
  borderRadius: "6px",
};

const SC = {
  Container,
  forprofile,
  MUIButtonrt,
  LeftButton,
  RightButton,
  Subcaption,
};

export default SC;
